<template>
  <div class="blockquote text-center mt-3">
    <div style="height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #5d5d61; font-size: 14px">Copyright &copy;{{ copyright }} 江西双北数据科技有限公司</div>
    <div class="d-flex flex-row justify-content-center">
      <b-link href="http://www.beian.miit.gov.cn" target="_blank">
        <div style="height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #5d5d61; font-size: 14px">ICP备案号：赣ICP备20002083号</div>
      </b-link>
      <b-link href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=36010902000256" target="_blank" style="margin-left: 20px">
        <div class="d-flex flex-row">
          <b-img style="height: 20px; line-height: 20px" :src="gaba" />
          <div style="height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #5d5d61; font-size: 14px">赣公网安备 36010902000256号</div>
        </div>
      </b-link>
      <b-link :href="$ADMIN_URL + '/#/hr-license'" target="_blank">
        <div style="height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #5d5d61; font-size: 14px">人力资源许可证</div>
      </b-link>
      <b-link :href="$ADMIN_URL + '/#/business-license'" target="_blank">
        <div style="height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #5d5d61; font-size: 14px">企业营业执照</div>
      </b-link>
    </div>
  </div>
</template>

<script>
import Gaba from '@/assets/gaba.png'

export default {
  name: 'FootZone',
  data() {
    return {
      // 版权信息
      copyright: '',
      gaba: Gaba
    }
  },
  created() {
    // 初始化版权相关信息
    this.initCopyright()
  },
  methods: {
    // 初始化版权相关信息
    initCopyright() {
      const now = new Date()
      // 得到年份
      this.copyright = now.getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.root-sytle {
  font-size: 14px;
}
</style>
